import { CLEAR_REGISTRATION, SET_ATTRIBUTE } from '../actions/registration'

const REGISTRATION_REDUCER_INITIAL_STATE = {}

const registrationReducer = (state = REGISTRATION_REDUCER_INITIAL_STATE, action) => {
  switch (action.type) {
    case CLEAR_REGISTRATION:
      return REGISTRATION_REDUCER_INITIAL_STATE

    case SET_ATTRIBUTE:
      return {
        ...state,
        [action.attribute]: action.value,
      }

    default:
      return state
  }
}

export default registrationReducer



// WEBPACK FOOTER //
// ./src/reducers/registration.js